import React from "react";
import { createRoot } from "react-dom/client";
import App from "./modules/App/App";
import { GATrackingInit } from "./services/GATrackingService";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById("root")!;
const root = createRoot(container);

GATrackingInit();

root.render(<App />);
